import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Grid, styled, Typography } from '@mui/material';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import BookingHeader from '../components/BookingInfo/BookingHeader';
import Documents from '../components/BookingInfo/Documents';
import Qualifications from '../components/BookingInfo/Qualifications';
import CrtAvailability from '../components/Calendar/CrtAvailability';
import Loading from '../components/Loading';
import SimpleSnackbar from '../components/SnackBar/SimpleSnackbar';
import sendNotification from '../utils/sendNotification';
import { removeCrtToList } from '../redux/SchoolSlice';
// import { removeCrtToList } from '../redux/SchoolSlice';

// const useStyles = makeStyles(theme => ({
//     // teacherCardInfo: {
//     //     order: 2,
//     //     // [theme.breakpoints.up('sm')]: {
//     //     //     order: 1,
//     //     // },
//     // },
//     // bookingDateValue: {
//     //     padding: '0 0 10px 4px',
//     // },
// }));

const TeacherCard = styled('div')(({ theme }) => ({
    margin: '20px 20px 40px',
    padding: '20px',
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const validPermission = 'create:booking';

export const ViewSavedCrtProfile = props => {
    // const classes = useStyles();
    let match = useRouteMatch(
        '/casual-relief-teacher-list/saved-profile/:uniqueId'
    );
    //const id = 0;

    const { getAccessTokenSilently } = useAuth0();

    const { token } = useSelector(state => state.token);
    const tokenStatus = useSelector(state => state.token.status);
    const [notification, setNotification] = useState({
        message: '',
        open: false,
        severity: 'success',
    });

    const dispatch = useDispatch();

    let history = useHistory();

    const [state, setState] = useState({
        grade: [],
        processingBooking: 0,
        bookingResponse: '',
        saved: true,
    });

    const [teacher, setTeacher] = useState({
        teacherInitData: { name: '' },
        length: 0,
        loading: true,
    });

    const [schoolState, setSchoolState] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            if (token.permissions.includes(validPermission) === false)
                setState({
                    ...state,
                    redirectToHome: true,
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenStatus, token.Count, token.permissions]);

    function goBack() {
        history.push('/casual-relief-teacher-list');
    }

    useEffect(() => {
        const schoolAddress = props.school.school.Data.address;
        setSchoolState(schoolAddress.match(/\b([A-Z]{2,3})\b/)[1]);
    }, [props.school]);

    useEffect(() => {
        async function crtProfile() {
            console.log('Route', JSON.stringify(match));
            //Check if the list has the user in it.
            if (props.schoolStatus === 'succeeded') {
                var selected = props.school.school.Data.crtList.filter(user => {
                    console.log(user.uniqueId, match.params.uniqueId);
                    return user.uniqueId === match.params.uniqueId;
                });
                console.log('Use effect called for booking found', selected[0]);
                if (selected.length === 1) {
                    if (typeof teacher.teacherInitData.grades === 'undefined') {
                        const newToken = await getAccessTokenSilently({
                            scope: process.env.REACT_APP_scope,
                        });
                        let response = await axios.post(
                            '/getCrtProfile',
                            { id: selected[0]['gs1-pk'] },
                            {
                                baseURL: process.env.REACT_APP_API_GATEWAY,
                                url: `/getCrtProfile`,
                                timeout: 30000,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'authorization': 'Bearer ' + newToken,
                                },
                            }
                        );
                        let tempUser = {
                            firstName: selected[0].firstName,
                            lastName: selected[0].lastName,
                            id: selected[0]['gs1-pk'],
                            img: selected[0].img,
                            uniqueId: selected[0].uniqueId,
                            dateAdded: selected[0].sk1,
                        };
                        if (response.data.Message.Data.Count > 0) {
                            console.log(
                                'response',
                                response.data.Message.Data.Item
                            );
                            tempUser.bio = response.data.Message.Data.Item.bio;
                            tempUser.amountOfRatings =
                                response.data.Message.Data.Item.amountOfRatings;
                            tempUser.rating =
                                response.data.Message.Data.Item.rating;
                            tempUser.skills =
                                response.data.Message.Data.Item.skills;
                            tempUser.otherSkills =
                                response.data.Message.Data.Item.otherSkills;
                            tempUser.grades =
                                response.data.Message.Data.Item.grades;
                            tempUser.licenceList =
                                response.data.Message.Data.Item.licenceList;
                            setTeacher({
                                teacherInitData: tempUser,
                                count: selected.length,
                                loading: false,
                            });
                        } else {
                            setTeacher({
                                teacherInitData: {
                                    name: '',
                                    id: selected[0]['gs1-pk'],
                                },
                                count: 0,
                                loading: false,
                            });
                        }
                    }
                }
            }
        }
        crtProfile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.schoolStatus]);

    const removeSaved = async () => {
        try {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let requestData = {
                token: token,
                request: {
                    pk1: teacher.teacherInitData.id,
                    sk1: teacher.teacherInitData.dateAdded,
                    schoolId: props.school.school.Data.pk1,
                },
            };
            console.log('requestData, ', requestData);
            const outcome = await dispatch(removeCrtToList(requestData));
            setState({ ...state, saved: false });
            console.log('outcome', outcome);
            if (typeof outcome.error !== 'undefined') {
                sendNotification('error', 0, 'Failed to remove teacher');
            } else {
                sendNotification('success', 6000, 'Teacher removed');
            }
        } catch (err) {
            console.log('Error occurred removing CRT', err);
            setState({
                ...state,
                apiMessage: 'Error occurred removing CRT',
            });

            sendNotification('error', 0, 'Failed to remove teacher');
        }
    };

    const changeNotification = values => {
        console.log('values', values);
    };
    function setNotif(severity, autoHideDuration, description) {
        sendNotification(severity, autoHideDuration, description);
    }

    return (
        <>
            {teacher.loading ? (
                <Loading sx={{ width: '100%' }} />
            ) : (
                <Grid
                    container
                    directon="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {teacher.count > 0 ? (
                        <Grid item xs={12} sm={10}>
                            <TeacherCard>
                                <CardHeader
                                    sx={{ 'padding': '0px' }}
                                    action={
                                        <IconButton
                                            onClick={goBack}
                                            aria-label="settings"
                                            size="large"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    }
                                />
                                <div>
                                    <Grid
                                        container
                                        directon="column-reverse"
                                        alignItems="stretch"
                                    >
                                        <BookingHeader
                                            booking={{
                                                'teacherProfile':
                                                    teacher.teacherInitData.img,
                                                'teacherFirstName':
                                                    teacher.teacherInitData
                                                        .firstName,
                                                'teacherLastName':
                                                    teacher.teacherInitData
                                                        .lastName,
                                                'teacherBio':
                                                    teacher.teacherInitData.bio,
                                            }}
                                            licenceList={
                                                teacher.teacherInitData
                                                    .licenceList
                                            }
                                            schoolState={schoolState}
                                            teacherRating={
                                                teacher.teacherInitData.rating
                                            }
                                            teacherRatingAmount={
                                                teacher.teacherInitData
                                                    .amountOfRatings
                                            }
                                            userType="School"
                                        />
                                    </Grid>
                                    <Grid container>
                                        <CrtAvailability
                                            id={teacher.teacherInitData.id}
                                            school={props.school}
                                            setNotif={setNotif}
                                            //notification={changeNotification}
                                        />
                                    </Grid>

                                    <Grid container>
                                        <Qualifications
                                            skills={
                                                teacher.teacherInitData.skills
                                            }
                                            otherSkills={
                                                teacher.teacherInitData
                                                    .otherSkills
                                            }
                                            grades={
                                                teacher.teacherInitData.grades
                                            }
                                            gs1pk={teacher.teacherInitData.id}
                                            schoolId={
                                                props.school.school.Data.pk1
                                            }
                                        />
                                    </Grid>

                                    <Grid
                                        container
                                        directon="column-reverse"
                                        alignItems="flex-start"
                                        sx={{ marginTop: '30px' }}
                                    >
                                        <Documents
                                            gs1pk={teacher.teacherInitData.id}
                                            schoolId={
                                                props.school.school.Data.pk1
                                            }
                                            loadOnInit={false}
                                            filterResume={false}
                                        />

                                        <BookingButton
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            onClick={removeSaved}
                                            disabled={!state.saved}
                                            data-cy="remove-teacher"
                                        >
                                            Remove from Saved List
                                        </BookingButton>
                                        <BookingButton
                                            onClick={goBack}
                                            variant="outlined"
                                            color="secondary"
                                            size="large"
                                            data-cy="back"
                                        >
                                            Back
                                        </BookingButton>
                                    </Grid>
                                </div>
                            </TeacherCard>
                        </Grid>
                    ) : (
                        <Box
                            sx={{
                                padding: '20px',
                                marginTop: '50px',
                                boxShadow: '1px 0px 7px rgba(0, 0, 0, 0.5)',
                                borderRadius: '12px',
                                backgroundColor: '#FFF',
                                width: '350px',
                                textAlign: 'center',
                            }}
                        >
                            <Typography variant="h6">
                                No Teacher Found
                            </Typography>
                            <Grid container>
                                <Grid item xs={12}>
                                    <BookingButton
                                        sx={{
                                            width: '200px',
                                            marginTop: '50px',
                                        }}
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        onClick={removeSaved}
                                    >
                                        Remove from Saved List
                                    </BookingButton>
                                </Grid>
                                <Grid item xs={12}>
                                    <BookingButton
                                        onClick={goBack}
                                        variant="outlined"
                                        color="secondary"
                                        size="large"
                                    >
                                        Back
                                    </BookingButton>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    <SimpleSnackbar
                        message={notification.message}
                        open={notification.open}
                        severity={notification.severity}
                    />
                </Grid>
            )}
        </>
    );
};

export default withAuthenticationRequired(ViewSavedCrtProfile, {
    onRedirecting: () => <Loading />,
});
